import { BaseSvgIcon } from './BaseSvgIcon'

export const PencilIcon = (props: any) => {
  const { width = 18, height = 18, fill = 'currentColor', ...rest } = props

  return (
    <BaseSvgIcon width={width} height={height} viewBox="0 0 18 18" fill="none" {...rest}>
      <g clipPath="url(#clip0_924_214)">
        <path
          d="M9.48 4.065L1.7625 11.7825C1.47812 12.0674 1.2984 12.4401 1.2525 12.84L0.945002 15.54C0.924958 15.7299 0.945189 15.9218 1.00438 16.1033C1.06356 16.2849 1.16037 16.4519 1.28848 16.5934C1.4166 16.735 1.57313 16.8479 1.74786 16.9249C1.92259 17.0018 2.11158 17.0411 2.3025 17.04H2.46L5.16 16.7325C5.55833 16.6864 5.93019 16.5097 6.2175 16.23L13.935 8.505L9.48 4.065Z"
          fill={fill}
        />
        <path
          d="M16.545 3.41251L14.5875 1.45501C14.4238 1.29061 14.2292 1.16016 14.0149 1.07114C13.8006 0.982131 13.5708 0.93631 13.3388 0.93631C13.1067 0.93631 12.877 0.982131 12.6627 1.07114C12.4484 1.16016 12.2538 1.29061 12.09 1.45501L10.275 3.27001L14.73 7.72501L16.545 5.91001C16.7094 5.74626 16.8399 5.55165 16.9289 5.33736C17.0179 5.12307 17.0637 4.89331 17.0637 4.66126C17.0637 4.42922 17.0179 4.19946 16.9289 3.98517C16.8399 3.77087 16.7094 3.57627 16.545 3.41251Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_924_214">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </BaseSvgIcon>
  )
}
